export default "__VITE_ASSET__CakOndmT__"